import { defineStore } from 'pinia'

const supportedLocales = ['en', 'de', 'fr'] as const
type Locale = (typeof supportedLocales)[number]

const detectBrowserLanguage = (): Locale => {
  const navigatorLocale = (navigator.language || navigator.languages[0]) as string

  if (supportedLocales.includes(navigatorLocale as Locale)) {
    return navigatorLocale as Locale
  }

  const baseLocale = navigatorLocale.split('-')[0]
  if (supportedLocales.includes(baseLocale as Locale)) {
    return baseLocale as Locale
  }

  return 'en' // Fallback to English if no supported locale is found
}

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    locale: detectBrowserLanguage()
  }),

  actions: {
    setLocale(newLocale: Locale) {
      this.locale = newLocale
    }
  },

  getters: {
    getLocale(state): Locale {
      return state.locale
    }
  }
})
